import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import CorporatePurchasing from "../Pages/admin/CorporatePurchasing";
import PurchasingMeasurementUnits from "../Pages/admin/PurchasingMeasurementUnits";
import GlobalUsersRoles from "../Pages/GlobalUsersRoles";
import { readStoredAuthToken, readStoredUser } from "../utils/sessionUser";
import { canAccessCorporatePurchasing } from "./corporatePurchasingAccess";
import CorporatePurchasingPanel from "./CorporatePurchasingPanel";

export function CorporatePurchasingLegacyRedirect() {
  const location = useLocation();
  const section = location.pathname.split("/")[3];
  const target = ["tenders", "catalog", "suppliers", "units"].includes(section) ? section : "tenders";
  return <Navigate to={`/corporate-purchasing/${target}${location.search}`} replace />;
}

function CorporatePurchasingEntry() {
  const location = useLocation();
  return <Navigate to={`/corporate-purchasing/tenders${location.search}`} replace />;
}

export default function CorporatePurchasingApp() {
  const [user, setUser] = useState(readStoredUser);
  useEffect(() => {
    const syncSession = () => setUser(readStoredUser());
    window.addEventListener("palantir-session-updated", syncSession);
    window.addEventListener("storage", syncSession);
    return () => {
      window.removeEventListener("palantir-session-updated", syncSession);
      window.removeEventListener("storage", syncSession);
    };
  }, []);

  if (!readStoredAuthToken()) return <Navigate to="/" replace />;
  if (!canAccessCorporatePurchasing(user)) return <Navigate to="/select-workspace" replace />;

  return (
    <Routes>
      <Route element={<CorporatePurchasingPanel user={user} />}>
        <Route path="tenders" element={<CorporatePurchasing key="tenders" section="tenders" />} />
        <Route path="catalog" element={<CorporatePurchasing key="catalog" section="catalog" />} />
        <Route path="suppliers" element={<CorporatePurchasing key="suppliers" section="suppliers" />} />
        <Route path="units" element={<PurchasingMeasurementUnits />} />
        <Route path="settings/users" element={<GlobalUsersRoles embedded />} />
        <Route path="*" element={<CorporatePurchasingEntry />} />
      </Route>
    </Routes>
  );
}
